import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { RouterModule } from '@angular/router';
import { RegisterComponent } from './register.component';

@NgModule({
  imports: [SharedModule, RouterModule.forChild([{ path: '', component: RegisterComponent }])],
  exports: [RegisterComponent],
  declarations: [RegisterComponent],
})
export class RegisterModule {}
